import React from 'react'
import { Text } from 'components'
import commaNumber from 'comma-number'
import Icon from 'components/Icon/Icon'
import styles from './MoreFeatures.module.scss'

const MoreFeatures = ({ number, feature, icon }) => {
  if (!number || number === '00' || number === '0') {
    return null
  }

  const numberReplace = number.toString().replace('.', ',')
  const formattedNumber = commaNumber(numberReplace, '.', ',')

  return (
    <div className={styles.container}>
      <span className={styles.icon}>
        <Icon type={icon} color="primaryColor" />
      </span>
      <span className={styles.text}>
        <Text fontSize="small">
          {`${formattedNumber}${icon === 'footage' ? ' m²' : ''}`}
        </Text>
        <Text className={styles.label}>{feature}</Text>
      </span>
    </div>
  )
}

export default React.memo(MoreFeatures)
